import keycloak from '../../Keycloak';

const LogoutPage = ({ location }) => {
    window.localStorage.clear();
    keycloak.logout({ redirectUri: window.location.origin + '/login' + location.search });

    return  null;
};

export { LogoutPage };